import React from 'react';
import VagaDetalhes from '../components/VagaDetalhes';

export default function VagaDetalhesPage() {
  return (
    <div>
      <h5 className='reconect-text'>DETALHES DA VAGA</h5>
      <VagaDetalhes />
    </div>
  );
}
